export default __webpack_public_path__ + "static/media/16.3351b96d.png";